import { IMotivoNotificacao } from "@/interfaces/IMotivoNotificacao";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "MOTIVO_NOTIFICACAO/sync",
  (items: IMotivoNotificacao[]) => ({
    payload: { items },
  })
);

export const motivoNotificacaoAction = {
  sync,
};
